import gql from "graphql-tag";

export const CREATE_AGENT_MUTATION = gql`
  mutation CreateAgent($input: AgentInput!) {
    createAgent(input: $input) {
      statusCode
      message
      agent {
        tenantId
        agentId
        name
        description
        llmModel
        narrativeInstructions
        codeInterpreter
        userInput
        idleSessionTimeout
        actionGroups {
          groupName
          description
          actionType
        }
      }
    }
  }
`;
